import { render, staticRenderFns } from "./FilePreviewHocr.vue?vue&type=template&id=6c633144&scoped=true&"
import script from "./FilePreviewHocr.vue?vue&type=script&lang=ts&"
export * from "./FilePreviewHocr.vue?vue&type=script&lang=ts&"
import style0 from "./FilePreviewHocr.vue?vue&type=style&index=0&id=6c633144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c633144",
  null
  
)

export default component.exports